import { isEmpty } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Loader, UserContactAddressForm, useLeisurePurchaseContext } from 'components';
import { useFetch } from 'hooks';
import { setCart } from 'store';

const LeisureShippingStep = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user, userLoading, next } = useLeisurePurchaseContext();
  const { formState, watch, getValues } = useFormContext();
  const { call: shippingCall, loading: shippingLoading } = useFetch({ withSetState: false });

  const isValid = watch('shipping') && formState.isValid;

  const onNextClick = async () => {
    if (!isValid || isEmpty(user)) return;
    const address = getValues('shipping');

    // Save user shipping address for the current leisure purchase
    const { data } =
      (await shippingCall({
        service: 'checkout',
        path: `/${user.serialNumber}/cart/ticketing/shipping-address`,
        method: 'post',
        data: {
          email: user.email,
          phone: user.phone,
          firstname: address.firstname,
          lastname: address.lastname,
          street: address.street,
          streetExtra: address.complement1,
          streetExtra2: address.complement2,
          city: address.city,
          postalCode: address.postalCode,
          civility: address.civility,
          country: 'France'
        }
      })) || {};

    if (data?.status === 200) {
      dispatch(setCart(data.body));
      next();
    }
  };

  return (
    <div className="lg:w-[90%]">
      <UserContactAddressForm user={user} userLoading={userLoading} />

      <button type="button" className="btn purchase-btn" onClick={onNextClick} disabled={!isValid || shippingLoading}>
        {shippingLoading && <Loader loaderClass="w-4 h-4 text-white mr-2 shrink-0" />}
        {t('buttons.continue')}
      </button>
    </div>
  );
};

export default LeisureShippingStep;
